import { left, right } from 'fp-ts/es6/Either';
import { err } from './error';
export var getWindowInfo = function ($window) {
    var $document = $window.document;
    var $head = $document.head;
    var $body = $document.body;
    var $html = $document.querySelector('html');
    if (!($html instanceof HTMLHtmlElement)) {
        return left(err('Failed to get HTMLHtmlElement'));
    }
    if (!($body instanceof HTMLBodyElement)) {
        return left(err('Failed to get HTMLBodyElement'));
    }
    // const $canvas = $document.createElement('canvas')
    // const ctx = $canvas.getContext('2d')
    // const $iframe = $document.createElement('iframe')
    // const $svg = $document.createElementNS(svgNS, 'svg')
    return right({
        window: $window,
        document: $document,
        html: $html,
        head: $head,
        body: $body
    });
};
